import 'jquery';
import 'fancybox';
import 'slick-carousel';
import 'scrollto';
import 'doubletaptogo';
import 'aos';
import 'odometer';

import './functions/initApp';